/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef } from "react"
import { Checkbox } from "antd"
import { CheckboxChangeEvent } from "antd/lib/checkbox"
import { useEffect, useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"

import { Button } from "components/Button"
import { Buttons } from "components/Card/Card"
import { GenericModal } from "components/Modal/Modal"
import PreviousButton from "components/Previous/PreviousButton"
import { PATH } from "containers/Survey/models"
import surveyActions from "containers/Survey/services/actions"
import { Reply } from "containers/Survey/types"
import { Dispatcher } from "types/redux"
import { DoctorsStore, SurveyStore } from "types/store"

import styles from "./Consent.module.scss"
import { useLanguage } from "locales"
import { TreatingDoctorStatus } from "types/entity"

const secondaryPurpose = {
  statistic: true,
  improvementClientService: true,
  improvementPlatformService: true,
  activityPromotion: true,
  partnersFollowing: true,
  sendReportToMT: true,
}
const rejectAllSecondaryPurpose = {
  statistic: false,
  improvementClientService: false,
  improvementPlatformService: false,
  activityPromotion: false,
  partnersFollowing: false,
  sendReportToMT: false,
}

const Consent = (props) => {
  const { languages } = useLanguage()
  const dispatch = useDispatch();
  const [consentMandatoryData, setConsentMandatoryData] = useState<boolean>(false);
  const [consentToDataUse, setConsentToDataUse] = useState<boolean>(false)
  const [showPrivacy, setShowPrivacy] = useState<boolean>(false)
  const [showConsentDetails, setShowConsentDetails] = useState(false);
  const treatingDoctorStatus = useSelector(({ survey }: { survey: SurveyStore }) => survey.answers.find((a) => a.questionId === PATH.doctor_available)?.value[0]) as number
  const [consentDetailsList, setConsentDetailsList] = useState(secondaryPurpose);
  const [hasClickedConsent, setHasClickedConsent] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if(!Object.values(consentDetailsList).find((value) => value === true)) {
      setConsentToDataUse(false);
    } else {
      setConsentToDataUse(true);
    }
  }, [consentDetailsList])

  useEffect(() => {
    setConsentMandatoryData(props.checked)
    setConsentToDataUse(props.checked);
    setConsentDetailsList(props.checked ? secondaryPurpose : rejectAllSecondaryPurpose)
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
  }, [props.checked])

  const surveyPushResponse = () => {
    props.unset()
    props.setStepReplies({
      replies: [
        {
          title: "share_personal_data",
          value: consentToDataUse,
        },
      ],
      id: PATH.consent,
    })
    if(consentDetailsList.sendReportToMT === true && treatingDoctorStatus === TreatingDoctorStatus.DOCTOR_AWAY_NO_CONSENT) {
      dispatch(surveyActions.sendReportToMTConsent(true))
    }
    if(consentDetailsList.sendReportToMT === false && treatingDoctorStatus === TreatingDoctorStatus.DOCTOR_AWAY_CONSENT) {
      dispatch(surveyActions.sendReportToMTConsent(false))
    } 
    props.onAccept()
  }
  const handleChange = (event: CheckboxChangeEvent) => {
    setConsentToDataUse(event.target.checked)
  }

  const previous = () => {
    if (hasClickedConsent) {
      if(consentDetailsList.sendReportToMT === true && treatingDoctorStatus === TreatingDoctorStatus.DOCTOR_AWAY_NO_CONSENT) {
        dispatch(surveyActions.sendReportToMTConsent(true))
      }
      if(consentDetailsList.sendReportToMT === false && treatingDoctorStatus === TreatingDoctorStatus.DOCTOR_AWAY_CONSENT) {
        dispatch(surveyActions.sendReportToMTConsent(false))
      }
    }
    props.onCancel()
  }
  return (
    <GenericModal
      visible={props.visible}
      footer={
        showPrivacy ? null : (
          <Buttons style={{ marginTop: 0 }} direction="vertical">
            <Button onClick={surveyPushResponse} type="primary">
              {languages.continue}
            </Button>
          </Buttons>
        )
      }
      title={undefined}
    >
      {showPrivacy ? (
        <div className={styles.CGUContent}>
          <PreviousButton onClick={() => setShowPrivacy(false)} />
          <iframe title="privacy" src="https://info.medadom.com/politique-de-confidentialite" style={{width: '-webkit-fill-available', height: '-webkit-fill-available'}} />
        </div>
      ) : (
        <div>
          <PreviousButton onClick={previous} />
          <h2 style={{ textAlign: 'center', color: "#211452", fontWeight: 'bold' }}>{languages.datas_and_consent_title}</h2>
          <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>{languages.datas_and_consent_point_2}</h3>
          <div className={`font-size-large ${styles.Content}`}>
            <div className={styles.Checkboxes}>
              <div className={styles.Checkbox}>
                <Checkbox
                  id="consent-data"
                  checked={consentMandatoryData}
                  onChange={(e) => {
                    setConsentMandatoryData(e.target.checked);
                    setHasClickedConsent(true);
                    props.onConsentChange(e.target.checked);
                    if(consentDetailsList.sendReportToMT === true && treatingDoctorStatus === TreatingDoctorStatus.DOCTOR_AWAY_NO_CONSENT) {
                      dispatch(surveyActions.sendReportToMTConsent(true))
                    }
                    if(consentDetailsList.sendReportToMT === false && treatingDoctorStatus === TreatingDoctorStatus.DOCTOR_AWAY_CONSENT) {
                      dispatch(surveyActions.sendReportToMTConsent(false))
                    }
                  }}
                  type="checkbox"
                />
                <label htmlFor="consent-data">
                  {languages.toASet} {" "} <b>{languages.obligatoryPurposes}</b> {" "} {languages.forMyParkour}
                </label>
              </div>
              <div className={styles.Checkbox}>
                <Checkbox
                  onChange={(e) => {
                    handleChange(e);
                    setHasClickedConsent(true);
                    if (e.target.checked) {
                      setConsentDetailsList(secondaryPurpose)
                    } else {
                      setConsentDetailsList(rejectAllSecondaryPurpose);
                    }
                  }}
                  type="checkbox"
                  checked={consentToDataUse}
                />
                <label>
                  {languages.toASet} {" "}<b><a onClick={() => {
                    setShowConsentDetails(!showConsentDetails)
                  }}>{languages.secondaryPurposes}</a></b> {" "} {languages.likeDoingStatistic}
                </label>
              </div>
              {
                showConsentDetails && (
                  <div style={{ marginLeft: '50px', marginTop: '10px' }}>
                    <div className={styles.Checkbox}>
                      <Checkbox
                        id="statistic"
                        checked={consentDetailsList.statistic}
                        onChange={(e) => setConsentDetailsList({ ...consentDetailsList, statistic: e.target.checked })}
                      />
                      <label htmlFor="statistic">
                        {languages.statisticsEstablishment}
                      </label>
                    </div>
                    <div className={styles.Checkbox}>
                      <Checkbox
                        id="improvementClientService"
                        checked={consentDetailsList.improvementClientService}
                        onChange={(e) => setConsentDetailsList({ ...consentDetailsList, improvementClientService: e.target.checked })}
                      />
                      <label htmlFor="improvementClientService">
                        {languages.clientServiceImprovment}
                      </label>
                    </div>
                    <div className={styles.Checkbox}>
                      <Checkbox
                        id="improvementPlatformService"
                        checked={consentDetailsList.improvementPlatformService}
                        onChange={(e) => setConsentDetailsList({ ...consentDetailsList, improvementPlatformService: e.target.checked })}
                      />
                      <label htmlFor="improvementPlatformService">
                        {languages.platformServiceImprovement}
                      </label>
                    </div>
                    <div className={styles.Checkbox}>
                      <Checkbox
                        id="activityPromotion"
                        checked={consentDetailsList.activityPromotion}
                        onChange={(e) => setConsentDetailsList({ ...consentDetailsList, activityPromotion: e.target.checked })}
                      />
                      <label htmlFor="activityPromotion">
                        {languages.activityPromotion}
                      </label>
                    </div>
                    <div className={styles.Checkbox}>
                      <Checkbox
                        id="partnersFollowing"
                        checked={consentDetailsList.partnersFollowing}
                        onChange={(e) => setConsentDetailsList({ ...consentDetailsList, partnersFollowing: e.target.checked })}
                      />
                      <label htmlFor="partnersFollowing">
                        {languages.partnersFollowing}
                      </label>
                    </div>
                    {
                      [TreatingDoctorStatus.DOCTOR_AWAY_CONSENT, TreatingDoctorStatus.DOCTOR_AWAY_NO_CONSENT].includes(treatingDoctorStatus) && (
                        <div className={styles.Checkbox}>
                          <Checkbox id="sendReportToMT"
                            checked={consentDetailsList.sendReportToMT}
                            onChange={(e) => {
                              dispatch(surveyActions.sendReportToMTConsent(e.target.checked))
                              setConsentDetailsList({...consentDetailsList, sendReportToMT: e.target.checked})
                            }}
                            >
                            <label style={{color: '#211452'}} htmlFor="sendReportToMT">
                              {languages.sendReportToMT}
                            </label>
                          </Checkbox>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>
            <div>
              <b>{languages.medadomAndPartners}</b>.{" "}
              {languages.forMoreInformation} {" "} <a onClick={() => setShowPrivacy(true)}> {" "}{languages.privacyPolicy}</a>
            </div>
          </div>
        </div>
      )}
    </GenericModal>
  )
}

const p = (dispatch: Dispatcher): Partial<SurveyStore> => {
  return {
    previous: () => dispatch(surveyActions.previous()),
    next: () => dispatch(surveyActions.next()),
    setStepReplies: (payload) =>
      dispatch(surveyActions.setStepReplies(payload)),
    unset: (unReplies?: Reply[]) =>
      dispatch(
        surveyActions.unsetStepReplies({ replies: unReplies, id: PATH.consent })
      ),
  } as Partial<DoctorsStore>
}

const s = ({ survey }: { survey: SurveyStore }) => {
  return {}
}

export default connect(s, p)(Consent)
